export enum CommonMessages {
  // Confirmation Messages
  AreYouSureWantTo = 'ZRBl',
  UnSubmittedChangeWhen = 'jSdi',
  UnsavedChangeWhen = 'EK4u',

  // Selection Messages
  MaxSelectableRowsError = 'lNrJ',

  // Status Messages
  Loading = '3DgI',
  LoadingPleaseWait = 'ppQg',
  NoRowsToShow = 'PvH2',

  // Toast Messages
  Success = 's94M',
  NotFound = 'Nd8F',
}
